import React, {useEffect, useRef, useState} from 'react';
import StartSection from "./sections/startSection/StartSection";
import './main.scss';
import GentleMegagripSection from "./sections/gentleMegatripSection/GentleMegagripSection";
import AdvantagesSection from "./sections/advantagesSection/AdvantagesSection";
import DiscoverersHameltemSection from "./sections/discoverersHameltem/DiscoverersHameltemSection";
import MatchOutfitSection from "./sections/matchOutfitSection/MatchOutfitSection";
import CollectionSection from "./sections/collectionSection/CollectionSection";
import SizesSection from "./sections/sizesSection/SizesSection";
import FooterSection from "./sections/footerSection/FooterSection";
import ReviewsSection from "./sections/reviewSection/ReviewsSection";
import FreeTieSection from "./sections/freeTieSection/FreeTieSection";
import {useTranslation} from "react-i18next";

const Main = () => {
	const { t, i18n } = useTranslation();
	const { language } = i18n;

	return (
		<div className="main">
			<div className="main__bg">
				<StartSection />
				<GentleMegagripSection />
				<AdvantagesSection />
				<DiscoverersHameltemSection />
				<MatchOutfitSection />
				<CollectionSection />
				<SizesSection />
				<ReviewsSection />
				<FreeTieSection />
				<FooterSection />
			</div>
		</div>
	);
};

export default Main;


/*useEffect(() => {
		const items = document.querySelectorAll('.main__bg_animations > div');

		const moveRandomly = () => {
			const pageHeight = document.documentElement.scrollHeight; // Полная высота страницы
			items.forEach((item: any, index: number) => {
				console.log("index: ", index);
				const randomX = Math.floor(index % 2 === 0 ? Math.random() * 10 : Math.random() * 90); // случайное смещение по ширине
				const randomY = Math.floor(Math.random() * pageHeight); // случайное смещение по всей высоте страницы
				item.style.transform = `translate(${randomX}vw, ${randomY}px)`;
			});
		};

		// Устанавливаем начальную позицию и начинаем перемещение
		moveRandomly();
		const interval = setInterval(moveRandomly, 50000); // перемещение каждые 5 секунд

		return () => clearInterval(interval); // очищаем интервал при размонтировании компонента
	}, []);*/